var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShirtO = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333,
  d: "m13.585 2.307-2.92-.973a2.667 2.667 0 1 1-5.333 0l-2.92.973a1.33 1.33 0 0 0-.893 1.487l.386 2.313a.67.67 0 0 0 .66.56H4v6.667c0 .733.6 1.333 1.333 1.333h5.333A1.333 1.333 0 0 0 12 13.334V6.667h1.433a.666.666 0 0 0 .66-.56l.387-2.313a1.334 1.334 0 0 0-.894-1.487"
})));
export default SvgShirtO;